import React from 'react'
import { Link } from 'react-router-dom'

import RestrictedComponent from '../../lib/components/form/RestrictedComponent'
import schema from '../../routes/permissions/schema'
import Preference from './Preference'

const NoPreferences = (props) => {
  return (
    <div className='alert alert-info'>
      <h4>No Embedded Event Listing Preferences Available.</h4>
      <p>
        <em>
          <RestrictedComponent permissionCheck={schema.MANAGE_CLIENT_CHANNEL_SETTINGS.CREATE}>
            <Link to='/manage/listing/edit'>Create one here &hellip;</Link>
          </RestrictedComponent>
        </em>
      </p>
    </div>
  )
}

const ListingManager = (props) => {
  if (!props.preferences.length) return <NoPreferences />

  const { preferences, actions, credentials, search } = props

  const matchesSearchFilter = (preference => {
    if (!search) return true
    const prefName = preference.preference.name
    return (
      prefName.toLowerCase().includes(search.toLowerCase()) ||
      search.toLowerCase().includes(prefName.toLowerCase())
    )
  })

  return (
    <div>
      {preferences.filter(matchesSearchFilter).map((pref) => {
        const { preferenceID, preference } = pref
        return (
          <Preference
            key={'listing-preference-' + preferenceID}
            preferenceID={preferenceID}
            preference={preference}
            actions={actions}
            credentials={credentials}
          />
        )
      })}
    </div>
  )
}

export default ListingManager
